import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";
import { Interaction, LineController } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import annotationPlugin from "chartjs-plugin-annotation";
import Interpolate from "./../charts/interpolate.js";
Chart.register(CategoryScale, zoomPlugin, annotationPlugin);

Number.prototype.twodig = function () {
	return Math.round(this * 100) / 100;
};

String.prototype.twodig = function () {
	return Math.round(this * 100) / 100;
};

Interaction.modes.interpolate = Interpolate;
const getLabelAndValue = LineController.prototype.getLabelAndValue;
LineController.prototype.getLabelAndValue = function (index) {
	if (index === -1) {
		const meta = this.getMeta();
		const pt = meta._pt;
		const vScale = meta.vScale;
		const iScale = meta.iScale;

		return {
			label: iScale.getLabelForValue(iScale.getValueForPixel(pt.x)),
			value: vScale.getValueForPixel(pt.y).twodig(),
		};
	}
	return getLabelAndValue.call(this, index);
};

// Plugin to draw the indicators
Chart.register({
	id: "indicators",
	afterDraw(chart) {
		const metas = chart.getSortedVisibleDatasetMetas();
		for (let i = 0; i < metas.length; i++) {
			const meta = metas[i];
			if (meta._pt) {
				meta._pt.draw(chart.ctx);
			}
		}
	},
	afterEvent(chart, args) {
		if (args.event.type === "mouseout") {
			const metas = chart.getSortedVisibleDatasetMetas();
			for (let i = 0; i < metas.length; i++) {
				metas[i]._pt = null;
			}
			args.changed = true;
		}
	},
});
